import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import cn from 'classnames'
import { isEmpty } from 'lodash'

import Image from '../components/Image'
import IconExit from '../components/icons/IconExit'
import Button from '../components/Button'
import IdleWarning from '../Main/IdleWarning'

import { toggleAppState } from '../../actions/appState'
import { menusRequested, currentMenuSelected } from '../../actions/menus'
import { clearCart } from '../../actions/cart'
import { getSelectedMenus } from '../../selectors/menus'
import UserIdleMonitor from '../utils/UserIdleMonitor'
import ImageVersioningContext from '../context/ImageVersioningContext'

class MenuSelect extends Component {
  static contextType = ImageVersioningContext

  constructor(props) {
    super(props)

    this.idleMonitor = new UserIdleMonitor(process.env.REACT_APP_DEV_IDLE_TIMEOUT || 30000)
  }

  componentDidMount() {
    const { menusRequested, clearCart, toggleAppState } = this.props

    this.idleMonitor.addEventListeners()
    menusRequested()
    clearCart()
    toggleAppState({
      isAgeConfirmed: false,
      isAlcoholWarningConfirmed: false,
    })
  }

  componentWillUnmount() {
    this.idleMonitor.removeEventListeners()
  }

  selectMenu = menuData => {
    const { currentMenuSelected, history } = this.props

    currentMenuSelected(menuData.uuid)
    history.push('/kiosk/order/new')
  }

  renderMenu = menuData => {
    const { isAvailable, shortDescription, images, name } = menuData
    const { getUrlWithVersion } = this.context

    return (
      <div key={menuData.uuid} className={cn('menu-select__item', { '-inactive': !isAvailable })}>
        {isAvailable && <Button className='menu-select__btn' onClick={() => this.selectMenu(menuData)}/>}
        <Image className='menu-select__image' url={getUrlWithVersion(images.detail)}/>
        <div className='menu-select__image-description'>
          <p className='menu-select__image-description__header'>{name}</p>
          <p>{isAvailable ? shortDescription : 'Closed'}</p>
        </div>
      </div>
    )
  }

  render() {
    const { menus } = this.props

    return (
      <>
        <IdleWarning />
        <div className='menu-select'>
          <NavLink
            className="menu__exit"
            to="/kiosk/attract_loop"
          >
            <IconExit className="menu__icon" />
            Exit
          </NavLink>
          <div className='menu-select__list'>
            {!isEmpty(menus) && menus.map(this.renderMenu)}
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  menus: getSelectedMenus(state),
})

const mapDispatchToProps = {
  menusRequested,
  currentMenuSelected,
  clearCart,
  toggleAppState,
}


export default connect(mapStateToProps, mapDispatchToProps)(MenuSelect)
